import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "mFooter",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onShare(type) {
      if (type == 'telegram') {
        open("https://t.me/Basedmemegroup", "_target");
      } else if (type == 'twitter') {
        open("https://x.com/basedmemex", "_target");
      }
    }
  }
};